import type { UploadFile } from 'antd/es/upload/interface';
import { getBaseImgLookUrl } from "@src/utils/constants";

/**
 * 格式化单个文件对象为antd Upload组件需要的格式
 * @param file 文件对象
 * @param fileUrl 文件URL转换函数
 * @returns 格式化后的文件对象
 */
export const formatFile = (file: any): UploadFile => ({
  name: file.name,
  size: file.size || 0,
  type: file.type || 'image/jpeg',
  uid: file.response?.retData || file.uid,
  url: getBaseImgLookUrl(file.response?.retData || file.url),
  status: file.status || 'done'
});

/**
 * 格式化文件列表为antd Upload组件需要的格式
 * @param list 文件列表
 * @param fileUrl 文件URL转换函数
 * @returns 格式化后的文件列表
 */
export const formatFileList = (list: any[]): UploadFile[] => {
  if (!list || !list.length) return [];

  return list.map((e) => ({
    uid: e?.imgUrl || e?.uid || e?.id,
    name: e?.imgName || e?.name || '文件',
    size: e?.size || 0,
    type: e?.type || 'image/jpeg',
    status: 'done',
    url: getBaseImgLookUrl(e?.imgUrl || e?.uid),
    thumbUrl: getBaseImgLookUrl(e?.imgUrl || e?.uid),
  }));
};


